import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { AppProviders, bootApp, createAppRouter } from "@empite/app-kit";
import "@empite/ui-components/styles.css";
import "./portal.css";
import { routeTree } from "./routes";

// Built once, at module scope. A QueryClient or a transport created inside a
// component is recreated on every render, which throws the cache away and
// turns a warm portal into a cold one.
//
// No onUnauthenticated handler, unlike the customer portal: browsing is a
// signed-out surface here, so a 401 from a member-only route is an ordinary
// answer for a visitor, not a session that expired. Each screen decides what
// to offer instead — see screens/common.tsx:RequireSession.
const context = bootApp();
const router = createAppRouter({ routeTree, context });

const root = document.getElementById("root");
if (!root) {
  throw new Error("index.html is missing #root");
}

createRoot(root).render(
  <StrictMode>
    <AppProviders queryClient={context.queryClient} transport={context.transport}>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
